import axios from 'axios';

// In production (deployed static site) set REACT_APP_API_URL to your Render backend URL.
// e.g. REACT_APP_API_URL=https://your-backend.onrender.com/api/v1
// In development the proxy in package.json forwards /api/v1 to localhost:8000.
const baseURL = process.env.REACT_APP_API_URL || '/api/v1';

const API = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

// Automatically include the correct token based on the user type (staff or regular user)
API.interceptors.request.use((config) => {
  const staffToken = localStorage.getItem('staff-token');
  if (staffToken) {
    config.headers.Authorization = `Bearer ${staffToken}`;
  } else {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export default API;
